module.exports = __webpack_public_path__ + "static/media/callWitDoc.eded15aa.jpg";